export default "__VITE_ASSET__DxLqvOiQ__"